var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.33,
    height: 16.329,
    viewBox: "0 0 16.33 16.329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#208ce1;stroke-linecap:round;stroke-width:2.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-148.732 -22.732)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1267.984,6950.157l12.794,12.794",
    transform: "translate(-1117.484 -6925.657)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1280.778,6950.157l-12.794,12.794",
    transform: "translate(-1117.484 -6925.657)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterClose);
export default __webpack_public_path__ + "static/media/filter_close.37181960d1d2771eafd83aacd7e9bfb7.svg";
export { ForwardRef as ReactComponent };